import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-796e5f2e")

_pushScopeId("data-v-796e5f2e")
const _hoisted_1 = { class: "dialogue-type-tag" }
const _hoisted_2 = {
  key: 0,
  class: "dialogue-type-tag-wrap tag-normal"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "tag-text" }, "普通", -1)
const _hoisted_4 = {
  key: 1,
  class: "dialogue-type-tag-wrap tag-task"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "tag-text" }, "任务", -1)
const _hoisted_6 = {
  key: 2,
  class: "dialogue-type-tag-wrap tag-deduction"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "tag-text" }, "推演", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.tagType === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.tagType === 1)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.tagType === 2)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
})